import { Injectable } from '@angular/core';

import { Address } from '../models/address.model';
import { TranslationService } from '@dch/ng-common';
import { IAddress } from '@dch/billing-business-logic';

@Injectable()
export class BillingAddressService {
  constructor(private translationService: TranslationService) {}

  public formatAddress(address: Address | IAddress): string {
    if (address === undefined) {
      return '';
    }
    return this.getStreetLine(address) + ', ' + this.getCityLine(address);
  }

  getStreetLine(address: Address | IAddress): string {
    let streetLine: string;

    function prefixWithComma() {
      if (streetLine.length > 0 && streetLine[streetLine.length - 1] !== ',') {
        streetLine += ',';
      }
    }

    if (address.street) {
      streetLine = address.street + ' ' + address.houseNumber;
    }
    if (address.houseNumberAlpha) {
      streetLine += address.houseNumberAlpha;
    }
    if (address.block) {
      prefixWithComma();
      streetLine +=
        ' ' +
        this.translationService.getTranslatedValueFor(
          'bills.settings.deliveryMethods.paper.address.block.prefix'
        ) +
        ' ' +
        address.block;
    }
    if (address.apartment) {
      prefixWithComma();
      streetLine +=
        ' ' +
        this.translationService.getTranslatedValueFor(
          'bills.settings.deliveryMethods.paper.address.appartment.prefix'
        ) +
        ' ' +
        address.apartment;
    }
    if (address.residence) {
      prefixWithComma();
      streetLine += ' ' + address.residence;
    }
    if (address.floor) {
      prefixWithComma();
      streetLine +=
        ' ' +
        this.translationService.getTranslatedValueFor(
          'bills.settings.deliveryMethods.paper.address.floor.prefix'
        ) +
        ' ' +
        address.floor;
    }
    if (address.box) {
      prefixWithComma();
      streetLine +=
        ' ' +
        this.translationService.getTranslatedValueFor(
          'bills.settings.deliveryMethods.paper.address.box.prefix'
        ) +
        ' ' +
        address.box;
    }
    return streetLine;
  }

  getCityLine(address: Address | IAddress): string {
    return `${address.zip ?? ''}${address.city ? ' ' + address.city : ''}`;
  }

  getResidenceStreetNumberAlphaFloorBox(address: IAddress): string {
    let streetLine = '';
    if (address.residence) {
      streetLine = address.residence + ', ';
    }
    if (address.street) {
      streetLine += address.street + ' ' + address.houseNumber;
    }
    if (address.houseNumberAlpha) {
      streetLine += address.houseNumberAlpha;
    }
    if (address.floor) {
      streetLine +=
        ', ' +
        this.translationService.getTranslatedValueFor(
          'bills.settings.deliveryMethods.paper.address.floor.prefix'
        ) +
        ' ' +
        address.floor;
    }
    if (address.box) {
      streetLine +=
        ', ' +
        this.translationService.getTranslatedValueFor(
          'bills.settings.deliveryMethods.paper.address.box.prefix'
        ) +
        ' ' +
        address.box;
    }
    return streetLine;
  }
}
